import React from 'react';
import ReactSelect from 'react-select';
import AsyncReactSelect from 'react-select/async';
import { withTheme } from 'styled-components';
import {
  customGenericStyles,
  customMultiSelectStyles,
  Placeholder,
  DropdownIndicator,
  NoOptionsMessage,
} from './Select.styles';

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- `any` preserves backward compatibility with consumers that don't specify the generic
export interface SelectOption<ValueType = any> {
  value: ValueType;
  label: string;
  'aria-label'?: string;
  isDisabled?: boolean;
}

const customComponents = {
  Placeholder,
  DropdownIndicator,
  NoOptionsMessage,
};

/**
 * Custom props interface to avoid generic type parameter issues with react-select's Props type.
 * react-select defines Props with 2-3 generic parameters that are difficult to satisfy in a union type.
 * This interface explicitly types known props and allows pass-through for react-select-specific options.
 */
interface SelectComponentProps {
  async?: boolean;
  components?: Record<string, unknown>;
  styles?: Record<string, unknown>;
  theme?: unknown;
  isMulti?: boolean;
  isDisabled?: boolean;
  isClearable?: boolean;
  isSearchable?: boolean;
  [key: string]: unknown;
}

function Select({
  async,
  components,
  styles,
  theme,
  isMulti,
  isDisabled,
  isClearable = true,
  isSearchable = true,
  ...props
}: SelectComponentProps) {
  const SelectComponent = (
    async ? AsyncReactSelect : ReactSelect
  ) as React.ComponentType<SelectComponentProps>;
  const customMultiStyles = isMulti && customMultiSelectStyles;
  return (
    <SelectComponent
      styles={{ ...customGenericStyles, ...styles, ...customMultiStyles }}
      components={{ ...customComponents, ...components }}
      theme={theme}
      isMulti={isMulti}
      isClearable={isClearable}
      isDisabled={isDisabled}
      isSearchable={isSearchable}
      {...props}
    />
  );
}

export default withTheme(Select);
